module.exports = __webpack_public_path__ + "img/intro-movie2@2x.fb2d22b9.png";